import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import dayjs from 'dayjs';
import SearchPanelBlock from '@components/Common/SearchPanelBlock';
import SlidePage from '@components/Common/SlidePage';
import * as Icons from '@components/Common/Icons';
import FeatureContent from '@components/Common/FeatureContent';
import ContactStaff from '@components/Common/ContactStaff';
import { homeDomain } from '@utils/domainForCompany';
import { createSearchPanel } from '@utils/creaeteSearchPanel';
import PrintLightbox from '@components/DetailPage/PrintLightbox';
import { SideBar } from '@utils/SideBar';
import '@magaele/ntb_lnsd';
import '@magaele/cd_gpsm';
import '@magaele/cd_gpsm/css.css';
import '@magaele/ntb_lnsd/css.css';
import '@magaele/ic-ln/css.css';
import 'normalize.css';
import { Link } from 'react-scroll';
import { useMediaQuery } from 'react-responsive';
import { RootState, store } from '@Redux/detail/store';
import { useTranslation } from 'react-i18next';
import {
    SubTitle,
    Table,
    GroupHead,
    GroupAllCalendar,
    GroupAllList,
    GroupAllModeswitcher,
    GroupAllTours,
    GroupDetail,
    GroupTripInfo,
    ItineraryDaily,
    ItineraryDailyLightbox,
    ItineraryNoticesFrame,
    ItineryTravelInfoM,
    ItineryTravelInfoPC,
    ItinerarySelfGuided,
    GroupNotesUpdatetime,
    GroupDetailPrice,
} from '@components/DetailPage';
import {
    setCalendarGroupsMonth,
    setGroupAllCalendar,
    setGroupAllTours,
    setPricesInfo,
    setStationInfo,
    // setSki,
    setFlightInfo,
    setCalendarGroupsMode,
    setCalendarGuaranteed,
    setCalendarGuaranteedChecked,
    setCalendarParmIsEnsureGroup,
    setIsHeaderShow,
    setCallJson,
    setIsSearchPanelFixed,
} from '@Redux/detail/Group/actions';
import { setItineraries, setOptionalInfo, setNoticeinfo } from '@Redux/detail/Itineraries/actions';
import { I_Group, I_StationInfoList } from '@Redux/detail/Group/interfaces';
import { I_OptionalInfo } from '@Redux/detail/Itineraries/interfaces';
import { ICollapseListProps, Button } from '@lion-design/core';
import { changeDetailHistory } from '@utils/utils';

import { setPageType } from '@Redux/common/Page/actions';

import 'normalize.css';
import '@magaele/tb_lnrw/css.css';
import './styles.scss';
import GroupNotesCansold from '@components/DetailPage/GroupNotesCansold';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import i18n from '@utils/i18n';

declare global {
    interface Window {
        dataLayer: any;
    }
}

i18n();

const SearchPanelBlockM = () => {
    const [isOpenPanel, setIsOpenPanel] = useState<boolean>(false);
    const { isSearchPanelFixed } = useSelector((state: RootState) => state.groupReducer);
    const dispatch = useDispatch();
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { GroupInfo }: I_Group = JSON.parse(travelinfo!);

    useScrollPosition(({ prevPos, currPos }) => {
        if (GroupInfo.GroupID) {
            const isFeatureIntoScreen =
                -currPos.y + window.innerHeight >
                (document.querySelector('.itinerary_wrapper') as HTMLDivElement).offsetTop;
            const isBelowFifty = -currPos.y > 50;
            isFeatureIntoScreen && isBelowFifty
                ? dispatch(setIsHeaderShow(true))
                : dispatch(setIsHeaderShow(false));
        }

        const isSrollPage = -currPos.y > 0;
        isSrollPage
            ? dispatch(setIsSearchPanelFixed(true))
            : dispatch(setIsSearchPanelFixed(false));
    });

    useEffect(() => {
        createSearchPanel({ device: 'M', mCloseBtn: setIsOpenPanel });
    }, []);

    const moduleName = 'searchPanel_block_m';

    return (
        <div className={cN(moduleName, isSearchPanelFixed ? 'fixed' : '')}>
            <span className={cN(`${moduleName}_input`)} onClick={() => setIsOpenPanel(true)}>
                <Icons.Magnifier fill="#fff" />
                <span>搜尋</span>
            </span>
            <SlidePage
                visible={isOpenPanel}
                setIsVisible={setIsOpenPanel}
                title="團體旅遊"
                isHeaderShow={false}
            >
                <div id="SearchPanelM" />
            </SlidePage>
        </div>
    );
};

declare global {
    interface Window {
        SearchPanel: any;
        Templates: {
            login_lion: {
                default: {
                    OpenLogin(): any;
                };
            };
        };
    }
}

enum themeTypes {
    bike = '9',
    cruise = '11',
    festival = '46',
    railway = '48',
    cuisine = '60',
    art = '61',
    bio = '62',
    sportBike = '63',
    music = '64',
    photography = '65',
    culture = '66',
    architecture = '67',
    creativity = '68',
    ruins = '70',
    camping = '71',
    parentChild = '73',
    adventure = '77',
    marathon = '76',
    farm = '81',
}

const getMonthStartAndEnd = (day: string) => {
    const start = dayjs(day).startOf('month').format('YYYY-MM-DD');
    const end = dayjs(day).endOf('month').format('YYYY-MM-DD');

    return [start, end];
};

interface I_Anchor {
    isShow: boolean;
    to: string; // 錨點連結位置
    text: string; // 錨點文字
}

const StickyHeader = () => {
    const { GroupInfo, isHeaderShow, callJson, TelType } = useSelector(
        (state: RootState) => state.groupReducer
    );
    const {
        Features,
        Remark,
        ActiveNote,
        SafeReg,
        LeaveTeamReg,
        DailyList,
        OptionalInfoList,
        ItinnotesReg,
    } = useSelector((state: RootState) => state.itinerariesReducer);
    const [isFeeOpen, setIsFeeOpen] = useState<boolean>(false);
    const [isContactOpen, setIsContactOpen] = useState<boolean>(false);
    const { t } = useTranslation();

    const isPC = useMediaQuery({ query: '(min-width: 980px)' });
    const currency = GroupInfo.CurrencyCode || '';

    const headerAnchors = [
        {
            isShow: !!Features,
            to: 'feature',
            text: '行程特色',
        },
        {
            isShow: DailyList.length > 0,
            to: 'schedules',
            text: '每日行程',
        },
        {
            isShow: OptionalInfoList.length > 0,
            to: 'activities',
            text: '自費活動',
        },
        {
            isShow: !!Remark,
            to: 'itineraryRemarks',
            text: '行程特殊提醒',
        },
        {
            isShow: !!ItinnotesReg && isPC,
            to: 'itineraryNote',
            text: '行程備註',
        },
        {
            isShow: !!ActiveNote && isPC,
            to: 'activeNote',
            text: '活動附註',
        },
        {
            isShow: !!SafeReg && isPC,
            to: 'safety',
            text: '安全守則',
        },
        {
            isShow: !!LeaveTeamReg && isPC,
            to: 'leaveTeam',
            text: '團體航班規定事項',
        },
    ];

    // 若為 "額滿"、"關團"、"取消"、"關團(因疫情）"，則 disable 按鈕
    const disabledBtn = [3, 5, 7, 99].includes(GroupInfo.Status);

    const statusText = (status: number) => {
        switch (status) {
            case 1:
                return '立即報名';
            case 2:
                return '候補';
            case 3:
                return '額滿';
            case 4:
                return '請洽專員';
            case 5:
                return t('closeGroup');
            case 6:
                return '預定';
            case 7:
                return '取消';
            case 8:
                return '我有意願';
            // 因應疫情
            case 99:
                return t('closeGroup');
            default:
                return '';
        }
    };

    return isHeaderShow ? (
        <div className="stickyHeader">
            <ul className="stickyHeader_wrapper">
                {headerAnchors.map(
                    (anchor: I_Anchor, i: number) =>
                        anchor.isShow && (
                            <li key={i} className="stickyHeader_item">
                                <Link
                                    activeClass="active"
                                    className="link"
                                    to={anchor.to}
                                    spy={true}
                                    smooth={true}
                                    duration={500}
                                    offset={-50}
                                >
                                    {anchor.text}
                                </Link>
                            </li>
                        )
                )}
                {isPC && (
                    <li className="stickyHeader_element">
                        {!disabledBtn && (
                            <>
                                <div className="price">
                                    <span className="price_rate">
                                        {GroupInfo.Status == 6
                                            ? '近期上架'
                                            : `${currency} ${GroupInfo.Price}`}
                                    </span>
                                    人/起
                                </div>
                                <GroupDetailPrice
                                    open={isFeeOpen}
                                    ToggleLightBox={() => setIsFeeOpen(false)}
                                />
                                <div className="price_info" onClick={() => setIsFeeOpen(true)}>
                                    費用說明
                                </div>
                                <Button
                                    className="btn-primary"
                                    {...(disabledBtn
                                        ? { disabled: true }
                                        : { href: GroupInfo.StatusUrl })}
                                    onClick={() => {
                                        GroupInfo.Status == 4 && setIsContactOpen(true);
                                    }}
                                >
                                    {statusText(GroupInfo.Status)}
                                </Button>
                                <ContactStaff
                                    open={isContactOpen}
                                    ToggleLightBox={() => {
                                        setIsContactOpen(false);
                                    }}
                                    origin="detail"
                                    callJson={callJson}
                                    GroupInfo={GroupInfo}
                                />
                            </>
                        )}
                    </li>
                )}
            </ul>
        </div>
    ) : null;
};

const Detail = () => {
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { GroupInfo }: I_Group = JSON.parse(travelinfo!);
    const dispatch = useDispatch();
    const [isPrintOpen, setIsPrintOpen] = useState<boolean>(false);
    const { groupReducer } = useSelector((store: RootState) => store);
    const { CalendarGroups } = groupReducer;
    const [gate, setGate] = useState(true);
    const ga4Arr: any = [];

    useEffect(() => {
        if (CalendarGroups?.isLoadingCalendar === true) {
            return;
        }
        dispatch(setCallJson('')); // 請洽專員資料
    }, [CalendarGroups?.isLoadingCalendar, dispatch]);

    useEffect(() => {
        const togglePrintLbx = (isOpen: boolean) => {
            setIsPrintOpen(isOpen);
        };
        SideBar(togglePrintLbx);
    }, []);

    useEffect(() => {
        //現在頁面
        dispatch(setPageType('detail'));
    }, [dispatch]);

    const secondLink = () => {
        const secondLink = {
            text: '',
            url: '',
        };

        if (GroupInfo.IsForeign) {
            if (GroupInfo.ThemeID.length > 0) {
                secondLink.text = '主題旅遊';
                secondLink.url = '/category/zh-tw/theme/';
            } else {
                secondLink.text = '國外團體';
                secondLink.url = '/category/zh-tw/travel/';
            }
        } else {
            if (GroupInfo.ThemeID.length > 0) {
                secondLink.text = '主題旅遊';
                secondLink.url = '/category/zh-tw/taiwantheme';
            } else {
                secondLink.text = '台灣團體';
                secondLink.url = '/category/zh-tw/taiwan/';
            }
        }

        return secondLink;
    };

    const routes = GroupInfo.GroupID
        ? [
              {
                  href: homeDomain,
                  text: '首頁',
              },
              {
                  href: `${homeDomain}${secondLink().url}`,
                  text: secondLink().text,
              },
              {
                  href: undefined,
                  text: GroupInfo.TourName,
              },
          ]
        : [
              {
                  href: homeDomain,
                  text: '公司首頁',
              },
              {
                  href: `${homeDomain}/category/zh-tw/taiwan/index`,
                  text: '台灣團體',
              },
              {
                  href: `${homeDomain}/category/zh-tw/travel/index`,
                  text: '國外團體',
                  spliter: '/',
              },
          ];

    //調整網址列參數
    useEffect(() => {
        changeDetailHistory({ NormGroupID: GroupInfo.NormGroupID, GroupID: GroupInfo.GroupID });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CalendarGroups.parmIsEnsureGroup]);

    const isMobile = useMediaQuery({ query: '(max-width: 476px)' });
    const themeImg = React.useCallback(() => {
        const { ThemeID } = GroupInfo;

        // 沒有 ThemeID，則為一般團
        if (ThemeID.length <= 0) {
            return 'group';
        }

        // 若有 ThemeID，則以取第 1 項
        if (Object.values(themeTypes).includes(ThemeID[0] as themeTypes)) {
            return ThemeID[0];
        }

        // 若無對應，則回傳主題預設圖
        return '0';
    }, [GroupInfo]);

    const isprod = process.env.ENV === 'prod';
    // GroupID 為空值時，顯示"請洽專員"光箱

    const calculateDiscount = (orig: string, sales: string) => {
        const origNum = parseInt(orig.replace(/,/g, ''));
        const salesNum = parseInt(sales.replace(/,/g, ''));
        return ((origNum - salesNum) / origNum) * 100;
    };

    // 寫入ga4
    useEffect(() => {
        let getBreadCrumb = '';
        routes.forEach((route) => {
            getBreadCrumb += route.text;
        });

        // 定義ga4Data
        const ga4Data = {
            item_id: GroupInfo.GroupID,
            item_name: GroupInfo.TourName,
            affiliation:
                GroupInfo.TourBuName === '旅天下'
                    ? 'Uplan Travel'
                    : GroupInfo.TourBuName === '雄保'
                    ? 'Lionbobby'
                    : 'Lion Travel',
            currency: 'TWD',
            discount: GroupInfo.IsVip
                ? calculateDiscount(GroupInfo.OrigPrice, GroupInfo.Price).toFixed(2)
                : 0,
            item_brand: 'Lion Travel',
            item_category: getBreadCrumb.includes('台灣') ? 'B2CWebtwpd' : 'B2CWebpd',
            price: `${GroupInfo.Price}`.split(',').join(''),
        };
        ga4Arr.push(ga4Data);

        if (ga4Arr.length !== 0) {
            if (gate) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'view_item',
                    ecommerce: {
                        items: GroupInfo.Price !== null ? ga4Arr : '',
                    },
                });
                setGate(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupReducer]);
    return (
        <>
            <StickyHeader />
            <div className={cN('detail', `theme_${themeImg()}${isMobile ? '_m' : ''}`)}>
                {/* 正式機上舊的sidebar暫時使用，等新的出來再換掉 */}
                {isprod && <div className="ntb_lnsd hidden-xs hidden-sm" />}
                <div
                    id="sidebar_nion"
                    className="pge_conl"
                    data-sidebar-position="55"
                    data-sidebar-icon-favorite="false"
                    data-sidebar-icon-history="false"
                    data-sidebar-icon-compareb2c="false"
                    data-sidebar-icon-copytrip="false"
                    data-sidebar-icon-downloadtrip="false"
                    data-sidebar-icon-printtrip="true"
                    data-sidebar-icon-shares="true"
                    data-sidebar-icon-b2b-forward="false"
                    data-sidebar-icon-fb="true"
                    data-sidebar-icon-line-pc="true"
                    data-sidebar-icon-line-m="true"
                    data-sidebar-icon-comparebbc="true"
                    // style={{ display: isprod ? 'none' : '' }}
                />
                <SearchPanelBlock routes={routes} />
                <SearchPanelBlockM />
                {GroupInfo.GroupID && (
                    <>
                        <Group />
                        <Itinerary />
                        <PrintLightbox isOpen={isPrintOpen} togglePrintLbx={setIsPrintOpen} />
                    </>
                )}
            </div>
        </>
    );
};

const Group = () => {
    const { CalendarGroups, GroupInfo, Schedules, currentTourID, scheduleActive } = useSelector(
        (state: RootState) => state.groupReducer
    );
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ query: '(max-width: 476px)' });
    useEffect(() => {
        // 從 tourinfojson api 取得當月的總筆數後，選擇顯示為月曆或列表
        if (Schedules && CalendarGroups.groups?.length > 0) {
            const curTour = Schedules?.TourIDList.find(
                (TourIDItem: any) => TourIDItem.TourID === GroupInfo.TourID
            );
            let curMonthGroupSum = 0;
            const isList = true;
            const isCalendar = false;
            curTour?.TourSummaryList.forEach((TourSummaryItem: any) => {
                const { Year, Month, DaySum } = TourSummaryItem;
                if (`${Year}-${Month}` === CalendarGroups.month) {
                    curMonthGroupSum = DaySum;
                }
            });
            let mode;
            //是否有多行程
            if (!isMobile) {
                if (Schedules.TourIDList && Schedules.TourIDList.length > 1) {
                    //是否為全部行程
                    if (scheduleActive <= 0) {
                        mode = isList;
                    } else {
                        curMonthGroupSum < 8 ? (mode = isList) : (mode = isCalendar);
                    }
                } else {
                    //是否大於8天
                    curMonthGroupSum < 8 ? (mode = isList) : (mode = isCalendar);
                }
            } else {
                mode = isList;
            }
            dispatch(setCalendarGroupsMode(mode));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CalendarGroups.groups, Schedules]);

    // 從後端提供的 div 提供的資料預先載入
    useEffect(() => {
        const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
        const { GroupInfo }: I_Group = JSON.parse(travelinfo!);

        const GoDateMonth = dayjs(GroupInfo.GoDate).format('YYYY-MM');
        const [GoDateStart, GoDateEnd] = getMonthStartAndEnd(GroupInfo.GoDate);

        const scheduelsReqBody = {
            NormGroupID: GroupInfo.NormGroupID,
        };

        const calendarReqBody = {
            NormGroupID: GroupInfo.NormGroupID,
            GoDateStart,
            GoDateEnd,
            TourID: currentTourID,
        };

        const pricesReqBody = {
            GroupID: GroupInfo.GroupID,
        };

        const stationReqBody = {
            GroupID: GroupInfo.GroupID,
        };

        const flightInfoReqBody = {
            NormGroupID: GroupInfo.NormGroupID,
            GroupID: GroupInfo.GroupID,
            GoDate: dayjs(GroupInfo.GoDate).format('YYYY-MM-DD'),
        };

        dispatch(setGroupAllTours(scheduelsReqBody)); // 多行程
        dispatch(setGroupAllCalendar(calendarReqBody)); // 月曆
        dispatch(setCalendarGroupsMonth(GoDateMonth)); // 月曆月份
        dispatch(setPricesInfo(pricesReqBody)); // 團費說明
        dispatch(setStationInfo(stationReqBody)); // 集合地點
        dispatch(setFlightInfo(flightInfoReqBody)); // 航班詳情
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const urlParams = new URLSearchParams(window.location.search);
    let IsEnsureGroup: string | boolean | null = urlParams.get('IsEnsureGroup');

    if (IsEnsureGroup === 'true') {
        IsEnsureGroup = true;
    } else {
        IsEnsureGroup = false;
    }

    //取得IsEnsureGroup參數
    useEffect(() => {
        if (IsEnsureGroup) {
            dispatch(setCalendarParmIsEnsureGroup(true));
            dispatch(setCalendarGuaranteedChecked(true));
        } else {
            dispatch(setCalendarParmIsEnsureGroup(false));
            dispatch(setCalendarGuaranteedChecked(false));
        }
    }, [IsEnsureGroup, dispatch]);

    //確認月曆資料是否接無成團
    useEffect(() => {
        const isGuaranteedDisabled = CalendarGroups?.groups.every((item) => {
            return item.Guaranteed == false;
        });
        dispatch(setCalendarGuaranteed(isGuaranteedDisabled));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CalendarGroups.groups]);

    return (
        <div className="group_wrapper">
            <div className={cN('group', 'Container')}>
                <div className={cN('group_container_m')}>
                    <GroupHead />
                    <GroupDetail />
                    <div className="group_all">
                        <GroupAllTours />
                        <div className="group_all_calendar_wrapper">
                            <GroupAllModeswitcher />
                            <GroupAllList />
                            <GroupAllCalendar />
                        </div>
                    </div>
                </div>
                <GroupTripInfo isPlace={true} />
                <GroupTripInfo isPlace={false} />
                <div className="group_notations">
                    <GroupNotesCansold />
                    <GroupNotesUpdatetime />
                </div>
            </div>
        </div>
    );
};

export const Itinerary = () => {
    const dispatch = useDispatch();
    const { StationInfoList } = useSelector((store: RootState) => store.groupReducer);
    const {
        Features,
        OptionalInfoList,
        Remark,
        LeaveTeamReg,
        SafeReg,
        ActiveNote,
        EachTripList,
        NoteList,
        DailyList,
        AntiepReg,
        ItinnotesReg,
    } = useSelector((store: RootState) => store.itinerariesReducer);

    const isPc = useMediaQuery({ query: '(min-width: 980px)' });

    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { GroupInfo, IsPreview }: I_Group = JSON.parse(travelinfo!);

    useEffect(() => {
        const itinerariesReqbody = {
            TourID: GroupInfo.TourID,
            IsPreview: IsPreview,
            TravelType: GroupInfo.TravelType,
        };
        dispatch(setItineraries(itinerariesReqbody));
    }, [GroupInfo.TourID, GroupInfo.TravelType, IsPreview, dispatch]);

    useEffect(() => {
        const optionalReqbody = {
            GroupID: GroupInfo.GroupID,
        };
        const noticeReqBody = {
            GroupID: GroupInfo.GroupID,
        };
        dispatch(setOptionalInfo(optionalReqbody));
        dispatch(setNoticeinfo(noticeReqBody));
    }, [GroupInfo.GroupID, dispatch]);

    interface I_Table {
        title: string;
        content: string;
    }
    const TableContent: React.FC<I_Table> = ({ title, content }) => {
        return (
            <>
                <div className="title">{title}</div>
                {content ? (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: sanitize(content, {
                                allowedTags: false,
                                allowedAttributes: false,
                            }),
                        }}
                    />
                ) : (
                    <div>--</div>
                )}
            </>
        );
    };
    //集合地點
    const placeTitles: ICollapseListProps['titles'] = [
        {
            name: '集合地點',
            key: 'Place',
            size: '33.333%',
        },
        {
            name: '地址',
            key: 'Address',
            size: '33.333%',
        },
        {
            name: '集合時間',
            key: 'MusterTime',
            size: '33.333%',
        },
    ];

    const placeData = StationInfoList.map((StationInfoList: I_StationInfoList) => {
        const { Place, MusterTime, Address } = StationInfoList;
        return {
            Place: <TableContent title="集合地點" content={Place} />,
            MusterTime: <TableContent title="集合時間" content={MusterTime} />,
            Address: <TableContent title="地址" content={Address} />,
        };
    });

    //自費行程
    const activityTitles: ICollapseListProps['titles'] = [
        {
            name: '城市',
            key: 'CityName',
            size: '13%',
        },
        {
            name: '節目名稱',
            key: 'ProgramName',
            size: '13%',
        },
        {
            name: '簡介',
            key: 'Summary',
            size: '18%',
        },
        {
            name: '費用',
            key: 'Cost',
            size: '13%',
        },
        {
            name: '年齡說明',
            key: 'AgeDesc',
            size: '9%',
        },
        {
            name: '備註',
            key: 'Remarks',
            size: '27%',
        },
        {
            name: '危險',
            key: 'DangerLevel',
            size: '7%',
        },
    ];
    const activityData = OptionalInfoList.map((OptionalInfoList: I_OptionalInfo) => {
        const {
            CityName,
            ProgramName,
            Summary,
            CurrID,
            CurrName,
            AdultsCost,
            ChildCost,
            AgeDesc,
            Remarks,
            DangerLevel,
        } = OptionalInfoList;

        const adultCost = (CurrID || '') + ' ' + AdultsCost.toLocaleString();
        const childCost = (CurrID || '') + ' ' + ChildCost.toLocaleString();
        const Cost = `${CurrName || ''} <div> 大人 ${adultCost} </div>
            ${ChildCost > 0 ? `<div>小孩 ${childCost}</div>` : ''}`;

        return {
            CityName: <TableContent title="城市" content={CityName} />,
            ProgramName: <TableContent title="節目名稱" content={ProgramName} />,
            Summary: <TableContent title="簡介" content={Summary} />,
            Cost: <TableContent title="費用" content={Cost} />,
            AgeDesc: <TableContent title="年齡說明" content={AgeDesc} />,
            Remarks: <TableContent title="備註" content={Remarks} />,
            DangerLevel: <TableContent title="危險" content={DangerLevel} />,
        };
    });

    // 行程特殊提醒
    const noticeContent =
        Remark?.length > 0 &&
        parse(sanitize(Remark, { allowedTags: false, allowedAttributes: false }));
    //行程備註
    const itineraryNoteContent = ItinnotesReg?.length > 0 && parse(ItinnotesReg);
    // 安全守則
    const safetyContent = SafeReg?.length > 0 && parse(SafeReg);
    // 團體航班規定事項
    const leaveTeamContent = LeaveTeamReg?.length > 0 && parse(LeaveTeamReg);
    // 活動附註
    const activeNoteContent = ActiveNote?.length > 0 && parse(ActiveNote);
    // 防疫說明
    const antiepRegContent = AntiepReg?.length > 0 && parse(AntiepReg);

    const scrollOffset = isPc ? -70 : -50;

    return (
        <div className={cN('itinerary_wrapper', 'Container')}>
            <FeatureContent features={Features} />
            {StationInfoList.length > 0 && (
                <div className={cN('itinerary_table', 'place')} id="assemble">
                    <SubTitle texts={{ main: '集合地點', sub: 'Assembling Place' }} />
                    <Table titles={placeTitles} dataSource={placeData} />
                    <div className="itinerary_note">
                        集合時間僅為參考用，實際時間請以當團人員通知時間為準
                    </div>
                </div>
            )}

            {DailyList.length > 0 && (
                <>
                    <div className="itinerary" id="schedules">
                        <SubTitle texts={{ main: '每日行程', sub: 'Daily Itinerary' }} />
                        <ItineraryDaily />
                    </div>
                    <ItineraryDailyLightbox />
                </>
            )}
            {OptionalInfoList.length > 0 && (
                <div className={cN('itinerary_table', 'activity')} id="activities">
                    <SubTitle texts={{ main: '自費活動', sub: 'Activities' }} />
                    <Table titles={activityTitles} dataSource={activityData} />
                    <div className="itinerary_note">
                        自費活動項目以實際出發日為主。
                        <span>危險等級： A危險 B一些危險 C安全</span>
                    </div>
                </div>
            )}
            {EachTripList.length > 0 && (
                <div className="itinerary_self">
                    <SubTitle texts={{ main: '產品內容', sub: 'Contents' }} />
                    <ItinerarySelfGuided />
                </div>
            )}
            {!!AntiepReg && (
                <div className="itinerary_notice" id="EpidemicPrevention">
                    <ItineraryNoticesFrame
                        texts={{ main: '防疫規範', sub: 'Epidemic Prevention Norms' }}
                        scrollEleId="EpidemicPrevention"
                        scrollOffset={scrollOffset}
                    >
                        {antiepRegContent}
                    </ItineraryNoticesFrame>
                </div>
            )}
            {!!noticeContent && (
                <div className="itinerary_notice no_collapse" id="itineraryRemarks">
                    <SubTitle texts={{ main: '行程特殊提醒', sub: 'Itinerary Remarks' }} />
                    <div className="content">{noticeContent}</div>
                </div>
            )}
            {!!itineraryNoteContent && (
                <div className="itinerary_notice" id="itineraryNote">
                    <ItineraryNoticesFrame
                        texts={{ main: '行程備註', sub: 'Itinerary Notes' }}
                        scrollEleId="itineraryNote"
                        scrollOffset={scrollOffset}
                    >
                        {itineraryNoteContent}
                    </ItineraryNoticesFrame>
                </div>
            )}
            {!!activeNoteContent && (
                <div className="itinerary_notice" id="activeNote">
                    <ItineraryNoticesFrame
                        texts={{ main: '活動附註', sub: 'Activity Notes' }}
                        scrollEleId="activeNote"
                        scrollOffset={scrollOffset}
                    >
                        {activeNoteContent}
                    </ItineraryNoticesFrame>
                </div>
            )}
            {!!safetyContent && (
                <div className="itinerary_notice" id="safety">
                    <ItineraryNoticesFrame
                        texts={{ main: '安全守則', sub: 'Safety Rules' }}
                        scrollEleId="safety"
                        scrollOffset={scrollOffset}
                    >
                        {safetyContent}
                    </ItineraryNoticesFrame>
                </div>
            )}
            {!!leaveTeamContent && (
                <div className="itinerary_notice" id="leaveTeam">
                    <ItineraryNoticesFrame
                        texts={{ main: '團體航班規定事項', sub: 'Group Flight Rules' }}
                        scrollEleId="leaveTeam"
                        scrollOffset={scrollOffset}
                    >
                        {leaveTeamContent}
                    </ItineraryNoticesFrame>
                </div>
            )}
            {NoteList.length > 0 && (
                <div className="itinerary_infos" id="notices">
                    <SubTitle texts={{ main: '旅遊資訊', sub: 'Travel Information' }} />
                    <div className="itinerary_infos_pc">
                        <ItineryTravelInfoPC />
                    </div>
                    <div className="itinerary_infos_m">
                        <ItineryTravelInfoM />
                    </div>
                </div>
            )}
        </div>
    );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <Detail />
        </Provider>
    </React.StrictMode>
);

export default Detail;
